module.exports = __webpack_public_path__ + "static/img/5.37d7299.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/pagess/mobile/sky101/5.png
// module id = ctF1
// module chunks = 1